

// routes.js

import LoginPage from './components/pages/LoginPage.vue'
import AgreementPage from './components/pages/AgreementPage'
import ViewAgreementPage from './components/pages/ViewAgreementPage'
import RootPage from './components/pages/RootPage.vue'
import DashboardPage from './components/pages/DashboardPage.vue'
import OrganizationsPage from './components/pages/OrganizationsPage.vue'
import OrganizationDetailsPage from './components/pages/OrganizationDetailsPage'
import AthletesPage from './components/pages/AthletesPage.vue'
import SessionsPage from './components/pages/SessionsPage.vue'
import SessionDetailsPage from './components/pages/SessionDetailsPage.vue'
import UserDetailsPage from './components/pages/UserDetailsPage.vue'
import UserSetupPage from './components/pages/UserSetupPage.vue'

import { authGuard } from "./auth/authGuard";
import VueRouter from 'vue-router';

const routes = [
        { path: '/', name: 'Root', redirect: '/login', },
        { path: '/login', name: 'Login', component: LoginPage },
        { path: '/agreement/:agreementType', name: 'Agreement', component: AgreementPage },
        { path: '/view-agreement/:agreementType', name: 'ViewAgreement', component: ViewAgreementPage },
        { path: '/site', component: RootPage, beforeEnter: authGuard, children:[

                { path: '/', name: 'InnerRoot', redirect: '/org', },
                { path: '/user', name: 'UserDetails', component: UserDetailsPage },
                { path: '/setup', name: 'UserSetup', component: UserSetupPage },

                { path: '/org', name: 'OrganizationList', component: OrganizationsPage },
                { path: '/org/:orgId/details', name: 'Organization', component: OrganizationDetailsPage },

                { path: '/org/:orgId/dashboard', name: 'Dashboard', component: DashboardPage },

                { path: '/org/:orgId/athletes', name: 'AthleteList', component: AthletesPage },
                { path: '/org/:orgId/athletes/sessions', name: 'DefaultSessionList', component: SessionsPage },
                { path: '/org/:orgId/athletes/:athleteId/sessions', name: 'SessionList', component: SessionsPage },
                { path: '/org/:orgId/athletes/:athleteId/sessions/:sessionId', name: 'Session', component: SessionDetailsPage }
        ]}
    ];


export default new VueRouter({
        mode: 'history',
        routes: routes
});